import {GetReady, TextScene} from "./text";
import React, {useRef} from "react";
import {useBeatPump} from "./beatPump";

export const JFD3Title = ({isControl}) => {
    const logo = useRef(null);
    useBeatPump(logo);
    const commonProps = {
        src: 'logo-video.mp4',
        autoPlay: true,
        loop: true,
        muted: true,
        playsInline: true,
    };
    const videoStyle = {width: '90%', height: '90%', objectFit: 'contain'};
    if(isControl) return <>
        <div style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: '#000',
            zIndex: -1,
            pointerEvents: 'none',
        }}/>
        <div style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            paddingTop: 40,
            boxSizing: 'border-box',
            alignItems: 'flex-start',
            justifyContent: 'center',
            zIndex: 0,
        }}>
            <video ref={logo} {...commonProps} style={{...videoStyle, objectPosition: 'top', transformOrigin: 'center 30%', willChange: 'transform, filter'}} />
        </div>
    </>;
    return <video {...commonProps} style={videoStyle} />
}

export const Sizzler = ({isControl, num}) => {
    if(isControl) return <div></div>;

    const videoStyle = {width: '90%', height: '90%', objectFit: 'contain'};
    const commonProps = {
        src: 'logo-video.mp4',
        autoPlay: true,
        loop: true,
        muted: true,
        playsInline: true,
    };
    return <video {...commonProps} style={videoStyle} />
}

export const TitleVideo = ({isControl, name}) => {
    if(isControl) return <div></div>;

    return <>
        <style>{`
            @keyframes titleFadeIn {
                0% { opacity: 0; }
                100% { opacity: 1; }
            }
        `}</style>
        <img
            src={`/titles/${name}-portrait.jpg`}
            alt={name}
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                animation: 'titleFadeIn 800ms ease-out both',
            }}
        />
    </>;
}

export const Title = () => {
    return <div style={{height: '100%', width: '100%', textAlign: 'center'}}>
        <div className="evenly-distribute" style={{justifyContent: "center"}}>
            <div style={{color: '#fff'}}>
                <div style={{fontSize: 70}}>JUST</div>
                <div style={{fontSize: 70}}>FUCKING</div>
                <div style={{fontSize: 70}}>DANCE</div>
            </div>
            <div style={{
                padding: 10,
                marginLeft: 4,
                marginRight: 4,
                backgroundSize: '150% 90%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: 'url(flame-bg.gif)'
            }}>
                <div className="two" style={{fontSize: 220, textAlign: 'center'}}>2</div>
            </div>
        </div>
    </div>;
}

export const TitleNoTwo = () => {
    return <div style={{height: '100%', width: '100%', textAlign: 'center'}}>
        <div className="evenly-distribute" style={{justifyContent: "center"}}>
            <div style={{color: '#fff'}}>
                <div style={{fontSize: 70}}>JUST</div>
                <div style={{fontSize: 70}}>FUCKING</div>
                <div style={{fontSize: 70}}>DANCE</div>
            </div>
            <div style={{padding: 10, marginLeft: 4, marginRight: 4}}>
                <div style={{color: '#000', fontSize: 220, textAlign: 'center'}}>2</div>
            </div>
        </div>
    </div>;
}

export const TitleCard = ({isControl, lines, r, g, b}) => {
    return <TextScene isControl={isControl} lines={lines} textStyle={{fontFamily: "'Press Start 2P', cursive"}} />;
}

export const Blank = () => {
    return <div/>;
}

export const AlmostReady = ({isControl, username}) => {
    return <TextScene isControl={isControl} text={isControl ? 'Almost Ready' : username}/>;
}

export const GetReadyDisplay = ({isControl}) => {
    return <GetReady isControl={isControl}/>;
}

// Doors-open welcome card — sits as scene 0 while the crowd arrives.
export const EventWelcome = ({isControl, title = "THE BRASS FACTORY", subtitle = "MEMBERS' NIGHT", detail = 'WELCOME', background}) => {
    const card = <div style={{textAlign: 'center', color: '#fff'}}>
        <div style={{
            fontSize: isControl ? 44 : 22,
            fontWeight: 800,
            letterSpacing: '0.5em',
            opacity: 1,
            marginBottom: 18,
        }}>{title}</div>
        <div style={{
            fontSize: isControl ? 130 : 52,
            fontWeight: 900,
            fontStyle: 'italic',
            letterSpacing: '0.08em',
            lineHeight: 1.05,
            textShadow: '0 0 60px rgba(255,255,255,0.35)',
        }}>{subtitle}</div>
        <div style={{
            fontSize: isControl ? 30 : 16,
            fontWeight: 700,
            letterSpacing: '0.4em',
            opacity: 1,
            marginTop: 26,
        }}>{detail}</div>
    </div>;

    return <div style={{
        width: isControl ? '1500px' : '100%',
        height: isControl ? '900px' : '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: isControl ? 'flex-start' : undefined,
        backgroundColor: '#000',
        backgroundImage: background
            ? `linear-gradient(rgba(0,0,0,0.85), rgba(0,0,0,0.85)), url(${background})`
            : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    }}>{card}</div>;
};

export const PartyTechLogo = ({isControl}) => {
    const logo = <img
        src="/party-tech-white.png"
        alt="Party Tech"
        width="700"
    />;

    if (isControl) {
        return <div style={{
            width: '1600px',
            height: '900px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'flex-start',
            backgroundColor: 'black',
        }}>{logo}</div>;
    }
    return <div style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }}>{logo}</div>;
}
